import { toast } from 'react-toastify'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router'
import React, { useEffect, useRef, useState } from 'react'

import Gift from '../../Icons/Gift'
import Cart from '../../Icons/Cart'
import Star2 from '../../Icons/Star2'
import Flash from '../../Icons/Flash'
import useCart from 'store/CartProvider'
import Wishlist from 'components/Icons/Wishlist'
import Megaphone from 'components/Icons/Megaphone'
import BestPrice from 'components/Icons/BestPrice'
import useProduct from 'store/SingleProductProvider'
import { useWishlistContext } from 'store/WishlistContext'
import { percentageSaleCalculator, isInSale } from 'consts'
import { TagButton, WishlistButton } from './ProductItem.style'
import { onProductAddToCartEvent } from 'services/conversionevents'

const ProductItem = props => {
  const [expandedWidth, setExpandedWidth] = useState('')

  const history = useHistory()
  const textRef = useRef(null)
  const { addToCart, payMethod } = useCart()
  const { addToWishlist } = useWishlistContext()
  const { product, chosenVariants } = useProduct()

  const item = props.item || {}

  const itemAddedToCart = status => {
    let shouldRedirect = status === 'buy'

    setTimeout(() => {
      addToCart(item.sku, chosenVariants, true, shouldRedirect).then(() => {
        onProductAddToCartEvent(product, {
          payMethod: payMethod,
        })
        if (shouldRedirect) {
          history.push('/purchase')
        }
      })
    }, 300)
  }

  const handleCartClick = e => {
    e.preventDefault()
    itemAddedToCart('cart')
    toast.success('პროდუქტი დაემატა კალათაში')
  }

  const handleWishlistClick = e => {
    e.preventDefault()
    addToWishlist(item.sku, {})
  }

  useEffect(() => {
    if (textRef.current) {
      const textContentWidth = textRef.current.scrollWidth
      const totalCalculatedWidth = textContentWidth + 36

      setExpandedWidth(`${totalCalculatedWidth}px`)
    }
  }, [])

  const tagConfig = {
    fast: {
      icon: <Flash color="white" width="0.9rem" height="0.9rem" />,
      text: 'სწრაფი მიტანა',
      background: 'linear-gradient(to right top, #d658e8, #7f00ff)',
    },
    top: {
      icon: <Star2 color="white" size="1rem" />,
      text: 'პოპულარული',
      background: 'linear-gradient(to right top, #b2de00, #40bd00)',
    },
    gift: {
      icon: <Gift color="white" width="1rem" height="1rem" />,
      text: 'საჩუქარი',
      background: 'linear-gradient(to right top, #162131, #162139)',
    },
    last: {
      icon: <Megaphone color="white" size="0.8rem" />,
      text: 'ბოლო ერთეული',
      background: 'linear-gradient(84.78deg, #FF7E00 0%, #FF2000 100%)',
    },
    best: {
      icon: <BestPrice width="0.9rem" height="0.9rem" />,
      text: 'საუკეთესო ფასი',
      background: 'linear-gradient(to right top, #ffc94b, #ff7f17)',
    },
  }

  const currentTag = tagConfig[item.icon]

  return (
    <Link to={item.slug ? `/product/${item.slug}` : item.url ? item.url : '/'}>
      <div className="bg-white rounded-2xl overflow-hidden shadow-md transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-lg">
        <div className="relative h-[140px] md:h-[180px]">
          {isInSale(item.old_price, item.price) && item.stock_status !== 0 ? (
            <div className="absolute top-2 left-2 md:top-3 md:left-3 bg-red-500 text-white px-[7px] py-[2px] rounded-full text-xs md:text-[13px] font-semibold z-10">
              -{percentageSaleCalculator(item.old_price, item.price)}%
            </div>
          ) : null}

          <div className="absolute top-2 right-2 md:top-3 md:right-3 w-6 h-auto md:w-8">
            {currentTag && (
              <TagButton
                onClick={e => e.preventDefault()}
                className="group absolute top-0 right-0 h-6 w-6 md:h-8 md:w-8 rounded-full flex items-center z-10 justify-start text-white text-[11px] md:text-[13px] shadow-lg overflow-hidden transition-[width] duration-500 ease-in-out hover:w-[var(--expanded-width)]"
                style={{ '--expanded-width': expandedWidth }}
                background={currentTag.background}
              >
                <div className="ml-[0.3rem] mb-[2px] min-[1100px]:ml-[9px] w-[0.87rem] h-[0.87rem] flex items-center justify-center">
                  {currentTag.icon}
                </div>
                <span
                  ref={textRef}
                  className="mx-[0.37rem] min-[1100px]:mt-0 mt-[1px] font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-400 ease-in-out"
                >
                  {currentTag.text}
                </span>
              </TagButton>
            )}

            <WishlistButton
              className={`absolute right-0 w-6 h-6 md:w-8 md:h-8 rounded-full flex items-center justify-center hover:shadow-[0_4px_16px_rgba(236,72,153,0.25)] hover:bg-[#fce7f3] text-[#2c3e50] transition-all duration-200 hover:scale-105 shadow-[0_2px_8px_rgba(0,0,0,0.1)] hover:text-[#ec4899] ${
                currentTag ? 'top-8 md:top-10' : 'top-0'
              }`}
              type="button"
              onClick={handleWishlistClick}
            >
              <Wishlist height={16} width={16} />
            </WishlistButton>
          </div>

          <img
            src={item.image}
            alt={item.name}
            className="w-full h-full object-contain"
          />
        </div>

        <div className="p-3 md:p-5">
          <div className="mb-2 md:mb-3 min-h-[18px]">
            {(item.stock_status === 1 || item.stock_status === 3) && (
              <div className="flex gap-1 items-center text-[#5fb20a] text-[11px] md:text-[13px] font-semibold">
                <div className="w-1.5 h-1.5 bg-[#5fb20a] rounded-full"></div>
                მარაგშია
              </div>
            )}
            {item.stock_status === 2 && (
              <div className="flex gap-1 items-center text-[#d4a418] text-[11px] md:text-[13px] font-semibold">
                <div className="w-1.5 h-1.5 bg-[#d4a418] rounded-full"></div>
                გადასამოწმებელია
              </div>
            )}
            {item.stock_status === 0 && (
              <div className="flex gap-1 items-center text-[#eb2f20] text-[11px] md:text-[13px] font-semibold">
                <div className="w-1.5 h-1.5 bg-[#eb2f20] rounded-full"></div>
                არ არის მარაგში
              </div>
            )}
          </div>

          <h3 className="text-[13px] md:text-[15px] font-semibold text-[#2c3e50] mb-2 md:mb-3 line-clamp-2 leading-tight h-[2.6em] md:h-[2.5em]">
            {item.name}
          </h3>

          <div
            className="flex items-center gap-1.5 md:gap-2 mb-2.5 md:mb-4"
            itemProp="offers"
            itemScope
            itemType="https://schema.org/Offer"
          >
            {item.price ? (
              <>
                <span
                  className="text-[15px] md:text-[19px] font-bold text-[#2c3e50]"
                  itemProp="price"
                  content={item.price}
                >
                  {item.price}
                  <span itemProp="priceCurrency" content="GEL">
                    ₾
                  </span>
                </span>
                {isInSale(item.old_price, item.price) && (
                  <span className="text-[11px] md:text-[13px] text-[#7f8c8d] line-through">
                    {item.old_price}₾
                  </span>
                )}
              </>
            ) : null}
          </div>

          <div className="flex gap-1 md:gap-2 justify-between items-center">
            <button
              onClick={handleCartClick}
              className="w-7 h-7 md:w-9 md:h-9 rounded-full flex items-center justify-center hover:shadow-[0_4px_16px_rgba(255,65,108,0.25)] hover:bg-[#fef2f2] transition-all duration-200 hover:scale-105 shadow-[0_2px_8px_rgba(0,0,0,0.1)] text-slate-600 hover:text-[#ff416c] flex-shrink-0"
            >
              <Cart height={16} width={16} />
            </button>
            <button className="flex-1 py-1.5 md:py-2.5 bg-[linear-gradient(to_right_top,#ff4b2b,#ff453e,#ff424e,#ff405d,#ff416c)] text-white rounded-full font-semibold hover:shadow-[0_6px_20px_rgba(255,65,108,0.4)] transition-all duration-200 text-[13px] md:text-[15px]">
              ყიდვა
            </button>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default ProductItem
